import React, { useContext, useEffect, useMemo, useRef } from 'react'
import { useLocation, useRouteMatch } from 'react-router-dom'
import Navigation from './Navigation'
import NavBar from './NavBar'
import Breadcrumb from './Breadcrumb'
import PatientHeader from './PatientHeader'
import Configuration from './Configuration'
import DetectOffline from 'components/Network/DetectOffline'
import NotificationBar from 'components/Notifications/NotificationBar'
import useWindowSize from '../../hooks/useWindowSize'
import useOutsideClick from '../../hooks/useOutsideClick'
import { ConfigContext } from '../../contexts/ConfigContext'
import * as actionType from '../../store/actions'
import VisitNavigation from './VisitNavigation'
import { TABLET_MIN_WIDTH } from 'config/constant'
import PcuHeader from './PcuHeader'
import AutoDebugFieldVisibility from 'components/DebugFieldVisibility/Auto'
import { getDebugVisibilityFormKey } from './debugVisibility'
const AdminLayout = ({ children, routes }) => {
  const location = useLocation()
  const debugVisibilityFormKey = useMemo(
    () => getDebugVisibilityFormKey(location.pathname, routes),
    [location.pathname, routes],
  )
  const windowSize = useWindowSize()
  const ref = useRef()
  const configContext = useContext(ConfigContext)

  const { collapseMenu, layout, subLayout, headerFixedLayout } =
    configContext.state
  const { dispatch } = configContext
  let patientRouteMatch = useRouteMatch('/patient-file/emr/:module/:submodule/')

  useOutsideClick(ref, () => {
    if (collapseMenu) {
      dispatch({ type: actionType.COLLAPSE_MENU })
    }
  })

  useEffect(() => {
    //FIXED ME : Removed temporary to test ipad-PRO , it remove collapsed
    if (
      windowSize.width > 992 &&
      windowSize.width <= 1024 &&
      layout !== 'horizontal'
    ) {
      // dispatch({type: actionType.COLLAPSE_MENU});
    }

    if (layout === 'horizontal' && windowSize.width < TABLET_MIN_WIDTH) {
      dispatch({ type: actionType.CHANGE_LAYOUT, layout: 'vertical' })
    }
  }, [dispatch, layout, windowSize])

  const mobileOutClickHandler = () => {
    if (windowSize.width < TABLET_MIN_WIDTH && collapseMenu) {
      dispatch({ type: actionType.COLLAPSE_MENU })
    }
  }

  let mainClass = ['pcoded-wrapper']
  if (layout === 'horizontal' && subLayout === 'horizontal-2') {
    mainClass = [...mainClass, 'container']
  }

  let common = (
    <React.Fragment>
      <Navigation />
      <NavBar />
    </React.Fragment>
  )

  if (windowSize.width < TABLET_MIN_WIDTH) {
    let outSideClass = ['nav-outside']
    if (collapseMenu) {
      outSideClass = [...outSideClass, 'mob-backdrop']
    }
    if (headerFixedLayout) {
      outSideClass = [...outSideClass, 'mob-fixed']
    }

    common = (
      <div className={outSideClass.join(' ')} ref={ref}>
        {common}
      </div>
    )
  }

  const vnBar = () => {
    if (patientRouteMatch) {
      return (
        <React.Fragment>
          <VisitNavigation />
        </React.Fragment>
      )
    } else {
      return null
    }
  }

  return (
    <React.Fragment>
      {vnBar()}
      {common}
      <div
        className={`pcoded-main-container ${
          patientRouteMatch ? 'has-multi-level-menu' : ''
        }`}
        onClick={mobileOutClickHandler}
      >
        <div className={mainClass.join(' ')}>
          <div className="pcoded-content">
            <div className="pcoded-inner-content">
              <DetectOffline />
              <Breadcrumb />
              <NotificationBar channelName="nav" />
              <PatientHeader />
              <PcuHeader />
              <AutoDebugFieldVisibility
                key={location.pathname}
                formKey={debugVisibilityFormKey}
                legacyFormKey={`auto-field-visibility:${location.pathname}`}
              >
                {children}
              </AutoDebugFieldVisibility>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default AdminLayout
